import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toast } from "react-toastify";
import {
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
} from "react-bootstrap";
import { FormattedMessage, FormattedHTMLMessage, intlShape } from "react-intl";
import { EnumValue, EnumWrapper } from "../../utils/enums";
import * as types from "../../utils/data/dataActionTypes";

import { BSModal } from "../common";
import {
  ChangePasswordButton,
} from "../common/ChangePassword";
import {
  ConfigurationsButton,
  ConfigurationsForm,
} from "../common/Configurations";
import MFAPreferenceForm from "../common/MFAPreference/MFAPreferenceForm";
import MFAPreferenceButton from "../common/MFAPreference/MFAPreferenceButton";
import HistoryNavigator from "../common/HistoryNavigator";
import SearchBox from "./search/SearchBox";
import { EN } from "../../components/common/enums/languages";
import { ROLES } from "../../utils/enums/enums";
import {
  INFORMATION_AGENT,
  PLAN_ADMINISTRATOR,
  AGENT,
  DIRECTOR,
  ADMINISTRATOR,
  FINANCE,
  FINTECH,
  MANAGER,
  INTERNAL_ROLES,
  EXTERNAL_ROLES,
  HR_CLERK
} from "../../utils/Roles";
import { CONFIGURATIONS, MEC_SERVICES, USER_MFA } from "../../utils/data/models";

import * as dataActions from "../../utils/data/dataActions";
import * as enumActions from "../../utils/enums/enumActions";
import * as loginActions from "../login/loginActions";
import logo from "../../assets/images/logo-white.png";

import Render from "../common/Render";
import downloadLogo from "../../assets/images/download-white.svg";
import notificationsLogo from "../../assets/images/notifications-white.svg";
import DownloaderModal from "../common/DownloaderModal";
import SyncedNotificationsList from "../dashboard/SyncedNotificationsList";
import ClientSelector from "./ClientSelector";
import userHasAccess from "../../utils/userHasAccess";
import * as loginTypes from "../login/loginActionTypes";

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showConfigurationsModal: false,
      showPasswordModal: false,
      passwordChanged: false,
      showDownloadsModal: false,
      showSyncNotificationsList: false,
      showMFAPreferenceModal: false,
      showValidatedMFAUpdateModal: false,
      mecServicesUrls: [],
      isAuthorizedToResetPassword: true
    };

    this.closeConfigurationsForm = this.closeConfigurationsForm.bind(this);
    this.closeMFAPreferenceForm = this.closeMFAPreferenceForm.bind(this);
    this.closeValidatedMFAUpdateModal = this.closeValidatedMFAUpdateModal.bind(this);
    this.closePasswordForm = this.closePasswordForm.bind(this);
    this.logout = this.logout.bind(this);
    this.onConfigurationsFormClick = this.onConfigurationsFormClick.bind(this);
    this.onMFAPreferenceFormClick = this.onMFAPreferenceFormClick.bind(this);
    this.onConfigurationsFormSubmit = this.onConfigurationsFormSubmit.bind(
      this
    );
    this.onMFAPreferenceFormSubmit = this.onMFAPreferenceFormSubmit.bind(this);
    this.openConfigurationsForm = this.openConfigurationsForm.bind(this);
    this.openMFAPreferenceForm = this.openMFAPreferenceForm.bind(this);
    this.openPasswordForm = this.openPasswordForm.bind(this);
    this.setPasswordChanged = this.setPasswordChanged.bind(this);
    this.openDownloadsModal = this.openDownloadsModal.bind(this);
    this.closeDownloadsModal = this.closeDownloadsModal.bind(this);
    this.openSyncNotificationsList = this.openSyncNotificationsList.bind(this);
    this.closeSyncNotificationsList = this.closeSyncNotificationsList.bind(this);
    this.closePasswordFormWithConfirmation = this.closePasswordFormWithConfirmation.bind(this);
    this.buildMecServicesLinks = this.buildMecServicesLinks.bind(this);
  }
  componentDidMount() {
    if (userHasAccess([ADMINISTRATOR, FINANCE, FINTECH, MANAGER, AGENT, DIRECTOR])) {
      this.props.dataActions.getDataItem(MEC_SERVICES, "").then((response) => {
        this.setState({ mecServicesUrls: this.buildMecServicesLinks(response.payload.data) });
      });
    }
  }

  closeConfigurationsForm() {
    this.setState({ showConfigurationsModal: false });
  }

  closeMFAPreferenceForm() {
    this.setState({ showMFAPreferenceModal: false });
  }

  closeValidatedMFAUpdateModal() {
    this.setState({ showValidatedMFAUpdateModal: false });
  }

  closePasswordForm() {
    this.setState({ showPasswordModal: false });
  }

  closePasswordFormWithConfirmation() {
    const userData = {
      emailAddress: this.props.user.emailAddress,
      username: this.props.user.username,
    };
    this.setState({ showPasswordModal: false });
    return this.props.loginActions.initiatePasswordReset(userData);
  }

  closeDownloadsModal() {
    this.setState({ showDownloadsModal: false });
  }

  closeSyncNotificationsList() {
    this.setState({ showSyncNotificationsList: false });
  }

  logout() {
    this.props.loginActions.logout().then((result) => {
      if (result.type == loginTypes.LOGOUT_FAILURE)
        toast(<FormattedMessage id="common.logoutError" />, {
          type: toast.TYPE.ERROR,
          autoClose: false,
        });
    });
  }

  onConfigurationsFormClick() {
    this.refs.configurationsForm.getWrappedInstance().submit();
  }

  onMFAPreferenceFormClick() {
    this.refs.mfaPreferenceForm.getWrappedInstance().submit();
  }

  onConfigurationsFormSubmit(fields) {
    const values = { ...fields };
    if (!values.isAuthorizationCodeSet) {
      delete values.authorizationCode;
    }
    if (
      typeof values.newMemberApprovalUserId === "string" &&
      !values.newMemberApprovalUserId.trim().length
    ) {
      values.newMemberApprovalUserId = null;
    }
    delete values.isAuthorizationCodeSet;
    return this.props.dataActions
      .updateDataItem(CONFIGURATIONS, values)
      .then(() => {
        this.setState({ showConfigurationsModal: false });
      });
  }

  onMFAPreferenceFormSubmit(fields) {
    const values = { ...fields };
    const { user } = this.props;
    if (values.mfaType == user.mfaType) {
      this.setState({ showMFAPreferenceModal: false });
      return;
    }
    const dict = { mfaType: values.mfaType };
    const model = { path: USER_MFA.path.replace("{}", user.userId) };
    return this.props.dataActions.updateDataItem(model, dict).then((data) => {
      if (data.type === types.UPDATE_DATA_ITEM_SUCCESS) {
        this.setState({ showValidatedMFAUpdateModal: true });
      }
      else {
        toast(<FormattedMessage id="validation.customMessages.serverErrors.mfaPreferenceUpdateError" />, {
          type: toast.TYPE.ERROR,
          autoClose: false,
        });
      }
      this.setState({ showMFAPreferenceModal: false });
    });
  }

  buildMecServicesLinks(mecServicesUrls) {
    const keys = Object.keys(mecServicesUrls);
    let links = [];
    let image = "";
    const userLanguage = localStorage.getItem("languageCode") || EN.value;

    keys.map((key) => {
      if (mecServicesUrls[key].image !== "") {
        image = `data:image/png;base64,${mecServicesUrls[key].image}`;
      }
      links = [...links, { "link": mecServicesUrls[key].link, "image": image, "label": mecServicesUrls[key].label[userLanguage], "title": mecServicesUrls[key].title[userLanguage] }];
    });
    return links;
  }

  openConfigurationsForm() {
    this.setState({ showConfigurationsModal: true });
  }

  openMFAPreferenceForm() {
    this.setState({ showMFAPreferenceModal: true });
  }

  openPasswordForm() {
    this.setState({ showPasswordModal: true });
  }

  setPasswordChanged() {
    this.setState({ passwordChanged: false });
  }

  openDownloadsModal() {
    this.setState({ showDownloadsModal: true });
  }

  openSyncNotificationsList() {
    this.setState({ showSyncNotificationsList: true });
  }

  render() {
    const dropdown = () => {
      return (
        <span className="header-user">
          <div className="header-user-text">
            <span className="header-user-name">
              {this.props.user.firstName + " " + this.props.user.lastName}
            </span>
            <span className="header-user-role">
              <EnumWrapper enum={ROLES}>
                <EnumValue enumKey={this.props.user.roleId} />
              </EnumWrapper>
            </span>
          </div>
        </span>
      );
    };

    const {
      submittingAuthorizationCode, user,
    } = this.props;
    return (
      <Navbar>
        <Navbar.Header>
          <div className="navbar-left">
            <Render for={[INFORMATION_AGENT, PLAN_ADMINISTRATOR, HR_CLERK]} only>
              <div className="logo">
                <img src={logo} width="150" />
              </div>
            </Render>

            <HistoryNavigator />
            
             <Render for={EXTERNAL_ROLES} only>
              <ClientSelector />
             </Render>

            <SearchBox intl={this.context.intl} />
          </div>
          {this.state.mecServicesUrls.length > 0 && (
            <Render for={[ADMINISTRATOR, FINANCE, FINTECH, MANAGER, AGENT, DIRECTOR]} only>
              <div className="mec-services-links-flex">
                {this.state.mecServicesUrls.map((item, index) => {
                  return (
                    <div key={index} className="mec-services-link-item">
                      <a key={index} href={item.link} target="_blank">
                        <span key={index}>{item.label} </span>
                      </a>
                    </div>
                  );
                })}
              </div>
            </Render>
          )}
        </Navbar.Header>
        <Nav bsClass="nav" pullRight={true}>
          <Render for={INTERNAL_ROLES} only>
            <li className="navbar-icon-right">
              <img
                onClick={this.openSyncNotificationsList}
                className="sync-notifications-icon"
                src={notificationsLogo}
              />
            </li>
          </Render>
          <Render>
            <li className="navbar-icon-right">
              <img
                onClick={this.openDownloadsModal}
                className="download-icon"
                src={downloadLogo}
              />
            </li>
          </Render>
          <NavDropdown
            eventKey="4"
            className="header-user-dropdown"
            title={dropdown()}
            id="profile-dropdown"
          >
            <Render if={this.state.isAuthorizedToResetPassword}>
              <ChangePasswordButton onClickHandler={this.openPasswordForm} />
            </Render>
            <Render for={DIRECTOR}>
              <ConfigurationsButton
                onClickHandler={this.openConfigurationsForm}
              />
            </Render>
            <Render for={AGENT}>
              <MFAPreferenceButton
                onClickHandler={this.openMFAPreferenceForm}
              />
            </Render>
            <NavItem onClick={this.logout}>
              <span className="rotate180 icon icon-log-out" />
              <FormattedMessage id="common.logout" />
            </NavItem>
          </NavDropdown>

        </Nav>

        {this.state.showDownloadsModal && (
          <DownloaderModal
            showDownloadsModal={this.state.showDownloadsModal}
            showDownloadsTitle={<FormattedMessage id="downloadsModal.title" />}
            onClose={this.closeDownloadsModal}
          />
        )}

        {this.state.showSyncNotificationsList && (
          <SyncedNotificationsList
            showSyncNotificationsList={this.state.showSyncNotificationsList}
            onClose={this.closeSyncNotificationsList}
          />
        )}
        <BSModal
          show={this.state.showPasswordModal}
          title={<FormattedMessage id="passwordForm.passwordMessage">{(f) => <span className="icon warning">{f}</span>}</FormattedMessage>}
          actions={[
            {
              id: 1,
              text: <FormattedMessage id="common.confirm" />,
              action: this.closePasswordFormWithConfirmation
            },
          ]}
          onClose={this.closePasswordForm}
        >
          <div>
            <FormattedHTMLMessage
              id="passwordForm.passwordMessageBody"
              values={{ emailAddress: this.props.user.emailAddress }} />
          </div>
        </BSModal>
        <BSModal
          show={this.state.showConfigurationsModal}
          title={<FormattedMessage id="configurationsForm.configurations" />}
          actions={[
            {
              id: 1,
              disabled: submittingAuthorizationCode,
              text: <FormattedMessage id="common.confirm" />,
              action: this.onConfigurationsFormClick,
            },
          ]}
          onClose={this.closeConfigurationsForm}
        >
          <ConfigurationsForm
            ref={"configurationsForm"}
            onSubmit={this.onConfigurationsFormSubmit}
          />
        </BSModal>
        <BSModal
          show={this.state.showMFAPreferenceModal}
          title={<FormattedMessage id="mfaPreferenceForm.mfaPreference" />}
          onClose={this.closeMFAPreferenceForm}
          actions={[
            {
              id: 1,
              disabled: false,
              text: <FormattedMessage id="common.confirm" />,
              action: this.onMFAPreferenceFormClick,
            },
          ]}
        >
          <MFAPreferenceForm
            initialValues={user}
            ref={"mfaPreferenceForm"}
            onSubmit={this.onMFAPreferenceFormSubmit}
          />
        </BSModal>
        <BSModal
          show={this.state.showValidatedMFAUpdateModal}
          title={
            <FormattedMessage id="mfaPreferenceForm.successfullUpdate">
              {(f) => (
                <div className="flex flex-row text-center">
                  <div className="icon-container">
                    <span className="icon icon-checkmark approve-icon" />
                  </div>
                  <span className="success-message">{f}</span>
                </div>
              )}
            </FormattedMessage>}
          onClose={this.closeValidatedMFAUpdateModal}
        />
      </Navbar>
    );
  }
}

Header.propTypes = {
  dataActions: PropTypes.object,
  enumActions: PropTypes.object,
  loginActions: PropTypes.object,
  requestingPasswordChange: PropTypes.bool,
  submittingAuthorizationCode: PropTypes.bool,
  user: PropTypes.object,
};

Header.contextTypes = {
  router: PropTypes.object,
  intl: intlShape,
};

function mapStateToProps(state) {
  return {
    requestingPasswordChange: state.auth.requestingChange,
    submittingAuthorizationCode: state.data.submitting,
    user: state.auth.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
    enumActions: bindActionCreators(enumActions, dispatch),
    loginActions: bindActionCreators(loginActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/dashboard/Header.js